/**
 * Realiza o download de um arquivo base64.
 * @param {string} base64Data - Os dados do arquivo em base64.
 * @param {string} fileType - O tipo do arquivo (ex: pdf, xls, kmz).
 * @param {string} fileName - O nome do arquivo para download (ex: relatorio.pdf).
 */
const downloadBase64File = (base64Data, fileType, baseName) => {

// // TODO: Deixando retorno simulado
//   const simulatedResponsePDF = {
//     base64Data: "JVBERi0xLjUKJcfsj6IKNSAwIG9iago8PC9MaW5lYXJpemVkIDEvTCAxNjM4NS9PIDcvRSAzNjU0Ni9OIDMvVCAxNjM0MS9IIFsgMjAzIDIxMV0vVSAxNy9WIDMvQ29udGVudHMgNCAwIFIvQ3JvcEJveCBbMCAwIDYxMiA3OTJdL1R5cGUvUGFnZT4+CmVuZG9iago=",
//     fileType: "pdf",
//   };

//   const simulatedResponseXLS = {
//     base64Data: "UEsFBgAAAAAAAAAAAAAAAAAAAAAAAA==",
//     fileType: "xls",
//   };

//   const simulatedResponseKMZ = {
//     base64Data: "UEsDBBQAAAAIAAaVyk5dqAAAAABMAAAAIAAAAYXBhY2hlbW9kLnhtbCCiBAIooAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
//     fileType: "kmz",
//   };


//   if (fileType === "pdf") {
//     base64Data = simulatedResponsePDF.base64Data;
//   } else if (fileType === "xls") {
//     base64Data = simulatedResponseXLS.base64Data;
//   } else if (fileType === "kmz") {
//     base64Data = simulatedResponseKMZ.base64Data;
//   }

  
  const fileName = generateUniqueFileName(baseName, fileType);

  try {
    // Decodifica o conteúdo base64
    const byteCharacters = atob(base64Data.base64);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);

    // Cria um Blob a partir dos dados
    const blob = new Blob([byteArray], { type: getMimeType(fileType) });

    // Cria uma URL para o Blob
    const url = URL.createObjectURL(blob);

    // Cria um link para download
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || `file.${fileType}`;
    document.body.appendChild(a);

    // Inicia o download
    a.click();

    // Remove o link depois do download
    a.remove();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao realizar o download do arquivo:", error);
  }
};

const normalizeApiFilePayload = (payload) => {
  if (!payload) return null;

  return {
    fileName: payload.FileName || payload.fileName,
    contentType: payload.ContentType || payload.contentType,
    contentFile: payload.ContentFile || payload.contentFile,
  };
};

const base64ToBlob = (base64, mimeType) => {
  const safeBase64 = (base64 || "").includes(",")
    ? (base64 || "").split(",").pop()
    : base64 || "";

  const byteCharacters = atob(safeBase64);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], {
    type: mimeType || "application/octet-stream",
  });
};

const triggerBrowserDownload = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "arquivo";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const normalizeExcelExtension = (extension) => {
  if (`${extension || ""}`.toLowerCase() === "xls") {
    return "xlsx";
  }

  return extension;
};

const downloadApiFile = (payload, fallbackType = "bin", fallbackBaseName = "GridReport") => {
  try {
    if (payload instanceof Blob) {
      const fileName = generateUniqueFileName(fallbackBaseName, fallbackType);
      triggerBrowserDownload(payload, fileName);
      return true;
    }

    const normalized = normalizeApiFilePayload(payload);
    if (!normalized || !normalized.contentFile) return false;

    const fileName =
      normalized.fileName ||
      generateUniqueFileName(fallbackBaseName, fallbackType);

    if (normalized.contentFile instanceof Blob) {
      triggerBrowserDownload(normalized.contentFile, fileName);
      return true;
    }

    if (Array.isArray(normalized.contentFile)) {
      const blob = new Blob([new Uint8Array(normalized.contentFile)], {
        type: normalized.contentType || getMimeType(fallbackType),
      });
      triggerBrowserDownload(blob, fileName);
      return true;
    }

    if (typeof normalized.contentFile === "string") {
      const blob = base64ToBlob(
        normalized.contentFile,
        normalized.contentType || getMimeType(fallbackType)
      );
      triggerBrowserDownload(blob, fileName);
      return true;
    }

    return false;
  } catch (error) {
    console.error("Erro ao realizar download do arquivo da API:", error);
    return false;
  }
};

/**
 * Mapeia o tipo de arquivo para o tipo MIME.
 * @param {string} fileType - O tipo do arquivo (ex: pdf, xls, kmz).
 * @returns {string} O tipo MIME correspondente.
 */
const getMimeType = (fileType) => {
  const normalizedType = `${fileType || ""}`.toLowerCase();

  if (normalizedType === "xlsx" || normalizedType === "xls") {
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  switch (fileType) {
    case 'pdf':
      return 'application/pdf';
    case 'kmz':
      return 'application/vnd.google-earth.kmz';
    default:
      return 'application/octet-stream';
  }
};

/**
 * Gera um nome de arquivo único com base na data e hora.
 * @param {string} baseName - O nome base do arquivo (ex: "relatorio").
 * @param {string} extension - A extensão do arquivo (ex: "pdf").
 * @returns {string} O nome do arquivo único (ex: "relatorio_20241120_152430.pdf").
 */
const generateUniqueFileName = (baseName, extension) => {
  const normalizedExtension = normalizeExcelExtension(extension);
  const now = new Date();
  const formattedDate = now
    .toISOString()
    .replace('T', '_') // Substitui o "T" por um "_"
    .replace(/:/g, '') // Remove os dois pontos
    .split('.')[0]; // Remove os milissegundos
  return `${baseName}_${formattedDate}.${normalizedExtension}`;
};

export const downloadService = {
  downloadBase64File,
  downloadApiFile
};

